import { useState } from "react";
import styles from "./DeleteItemBlock.module.css";
import { Message, Checkbox, Button } from "rsuite";
import ArrowDownIcon from "@rsuite/icons/ArrowDown";
import ArrowRightIcon from "@rsuite/icons/ArrowRight";
import { showToast } from "../Toast";

function DeleteItemBlock({ item, onDelete }) {
  let [checked, setChecked] = useState(false);
  // Collapsed by default — only the "Delete {item}" header shows until the
  // user clicks to expand the confirmation controls.
  const [expanded, setExpanded] = useState(false);

  function checkBoxHandler(v, checked) {
    setChecked(checked);
  }

  function toggleExpanded() {
    setExpanded((prev) => {
      // Reset the confirmation when collapsing so reopening starts clean.
      if (prev) setChecked(false);
      return !prev;
    });
  }

  function deleteItem() {
    if (!checked) {
      showToast("e", `Confirm ${item} deletion`);
      return;
    }

    onDelete();
  }

  return (
    <>
      <div className={`${styles.container} ${expanded ? "" : styles.collapsed}`}>
        <div
          className={styles.title}
          onClick={toggleExpanded}
          role="button"
          tabIndex={0}
        >
          <span className={styles.title_icon}>
            {expanded ? <ArrowDownIcon /> : <ArrowRightIcon />}
          </span>
          Delete {item}
        </div>

        {expanded && (
          <>
            <div className={styles.warning}>
              <div className={styles.warning_title}>
                Are you sure you want to delete this {item}?
              </div>
            </div>

            <Checkbox value={checked} onChange={checkBoxHandler}>
              {" "}
              I confirm {item} deletion
            </Checkbox>
            <Button
              onClick={deleteItem}
              style={{ width: "200px" }}
              color="red"
              appearance="primary"
            >
              Delete {item}
            </Button>
          </>
        )}
      </div>
    </>
  );
}

export default DeleteItemBlock;
